module.exports = __webpack_public_path__ + "static/icon.45644c1b.png";